import { render, staticRenderFns } from "./ConnectBrokerCard.vue?vue&type=template&id=2f6f636c&scoped=true&"
import script from "./ConnectBrokerCard.vue?vue&type=script&lang=ts&"
export * from "./ConnectBrokerCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectBrokerCard.vue?vue&type=style&index=0&id=2f6f636c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f636c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VImg,VLayout,VRow})
